import React, {useState} from 'react'
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import Logo from '../assets/logo.png';
import { useNavigate } from 'react-router-dom';

const AdminHeader = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  // Function to handle navbar collapse on link click
  const handleLinkClick = () => {
    setIsCollapsed(true); // Collapse the navbar after link click
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('username');
    localStorage.removeItem('isLoggedIn', 'true');
    navigate('/');
    window.location.reload();
}
  return (
    <>
      <section className='py-1'>
        <div className='container px-lg-5 px-4'>

          <div className='d-lg-flex d-md-flex d-sm-flex d-block justify-content-between'>

            <div className='text-muted my-lg-3 my-md-3 my-sm-3 my-2 text-center'><i className="fa-solid fa-envelope"></i> shekhar8858@gmail.com | <i className="fa-solid fa-phone"></i> 9696359735</div>

            <div className='my-lg-3 my-md-3 my-sm-3 my-2 text-center'>
              <Link className='header-icon'><i className="fa-brands px-3 fa-facebook-f"></i></Link>
              <Link className='header-icon'><i className="fa-brands px-3 fa-x-twitter"></i></Link>
              <Link className='header-icon'><i className="fa-brands px-3 fa-linkedin-in"></i></Link>
              <Link className='header-icon'><i className="fa-brands px-3 fa-instagram"></i></Link></div>
          </div>
          {/* flex ends */}


          <nav className="navbar navbar-expand-lg navbar-light bg-white">
            <div className="container-fluid">
              <Link className="navbar-brand py-0" to='/'><img src={Logo} className='img-fluid' alt='site logo' style={{height: '3.2em'}} /></Link>
              <button className="navbar-toggler" onClick={() => setIsCollapsed(!isCollapsed)} type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <i class="fa-solid fa-bars-progress"></i>
              </button>
              <div className={`collapse navbar-collapse ${isCollapsed ? '' : 'show'}`} id="navbarSupportedContent">
                <ul className="navbar-nav ms-auto mb-lg-0">
                  <li className="nav-item my-2">
                    <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to="/admin/dashboard">Dashboard</NavLink>
                  </li>
                  <li className="nav-item my-2">
                    <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to="/admin/bookings">Bookings</NavLink>
                  </li>
                  <li className="nav-item my-2">
                    <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to="/admin/enquiry">Form Enquiry</NavLink>
                  </li>
                  <li className='nav-item my-2'>
                    <p className='nav-text my-0' onClick={handleLogout}>Logout</p>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          {/* navbar ends */}

        </div>
      </section>
    </>
  )
}

export default AdminHeader
